import OverlayButton from "./OverlayButton";
import { Canvas } from "@react-three/fiber";
import ButtonContacts from "../../components/buttonContacts/buttonContacts";
import Experience from "../../components/experience/Experience";
import { useResetUserDataAndLanguage } from '../../functions/useResetUserDataAndLanguage';
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./homePage.module.css";

const HomePage = () => {
  const resetUserDataAndLanguage = useResetUserDataAndLanguage();
  const navigate = useNavigate();

  const hasReset = useRef(false);

  useEffect(() => {
    if (hasReset.current) return;
    hasReset.current = true;

    resetUserDataAndLanguage();
  }, [resetUserDataAndLanguage]);
    
  return (
    <>
      <OverlayButton />
      <Canvas
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 1,
          background: "transparent",
        }}
        gl={{ alpha: true }}
        shadows
        onClick={() => navigate("/home")}
      >
        <Experience />
      </Canvas>
      
      <div className={styles.contactsLocation}><ButtonContacts/></div>

    </>
  );
};

export default HomePage;
